import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { useSubmitedComment } from "./Hooks";
import ItemComment from "../../../../App/Panel/Comments/subsets/ItemComment";

function List({ isApp }) {
  const { loading, getList, list } = useSubmitedComment();
  useEffect(() => {
    getList();
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست نظر های من</title>
      </Helmet>

      {isApp && <>
        {loading.list
          ? <Loading col="12" height="50px" count="3" />
          : list.data.length > 0
            ? list.data.map((item, index) => (
              <ItemComment data={item} key={index} />
            ))
            : <p className="text-center mt-3 bg-transparent">  کامنتی یافت نشد !   </p>
        }
      </>}

      {!isApp && <DataTable
        loading={loading.list}
        needSearch={true}
        heads={[
          {
            title: "نظر برای",
            key: "commented",
            keyName: "name",
            keyName: "title",
            type: "state",
            method: row => {
              if (row) {
                if (row.rel_type == "Blog") {
                  return row.commented.title.toString().length > 25
                    ? row.commented.title.toString().substr(0, 25) + "..."
                    : row.commented.title;
                }
                if (row.rel_type == "Item") {
                  return row.commented.name;
                }
                if (row.rel_type == "SportClass") {
                  return row.commented.name;
                }
              } else {
                return "ثبت نشده";
              }
            },
          },
          {
            title: "مربوط به",
            key: "rel_type",
            type: "enum",
            enum: {
              Item: "مجموعه",
              Blog: "مقالات",
              SportClass: "کلاس",
            },
          },
          {
            title: "متن  کامنت",
            key: "text",
            type: "long",
          },
          {
            title: "وضعیت",
            key: "status",
            type: "enum",
            enum: {
              off: "در حال انتظار تایید",
              on: "تایید شده",
            },
          },
        ]}
        textEmpty="نظری ثبت نشده"
        list={list.data}
        data={list}
        function={getList}
        currentPage={list.current_page}
        header="لیست نظرات"
        links={[]}
      />}
    </Fragment>
  );
}
export default List;
